import { CheckIcon, JaneGoldIcon, Typography } from '@iheartjane/reefer';
import type { Nullable, Nullish } from '@iheartjane/types';

import { BrandLogo } from '@jane/bloom/components/gold/brandLogo';

import styles from './janeGoldSection.module.css';

interface JaneGoldSectionProps {
  brand: {
    logo_url: Nullish<string>;
    name: Nullable<string>;
  };
  isGoldUser: boolean;
  isSegmentedDeal: boolean;
  isSignedIn: boolean;
  title: string;
}

export function JaneGoldSection({
  brand,
  isGoldUser,
  isSegmentedDeal,
  isSignedIn,
  title,
}: JaneGoldSectionProps) {
  return (
    <div className={styles['janeGoldContainer']}>
      <div className={styles['janeGoldHeader']}>
        <JaneGoldIcon size="sm" />
        <Typography variant="body-semibold">Jane Gold</Typography>
      </div>
      <div className={styles['janeGoldInfoBox']}>
        <div>
          <div className={styles['janelogoContainer']}>
            {brand.name && (
              <BrandLogo name={brand.name} logo_url={brand.logo_url} />
            )}
            <div className={styles['janeGoldText']}>
              {!isSignedIn && isSegmentedDeal && (
                <Typography color="grays-mid">
                  Sign in for eligibility
                </Typography>
              )}
              <Typography variant="body-semibold">{title}</Typography>
            </div>
          </div>
        </div>
        <div>{isGoldUser && <CheckIcon />}</div>
      </div>
    </div>
  );
}
